// src/firebase/invoice/generateInvoiceNumber.ts
import { ref, get } from "firebase/database";
import { db } from "../firebaseConfig";
import {
	convertUTCToIST,
	getTodayUTCDateString,
} from "../../utils/calculations";

export const generateInvoiceNumber = async (): Promise<string> => {
	const nowUTC = new Date(getTodayUTCDateString());
	const yyyyUTC = nowUTC.getFullYear();
	const mmUTC = String(nowUTC.getMonth() + 1).padStart(2, "0");
	const ddUTC = String(nowUTC.getDate()).padStart(2, "0");
	const todayUTC = `${yyyyUTC}-${mmUTC}-${ddUTC}`; // e.g. 2025-10-23

	const nowIST = new Date(convertUTCToIST(getTodayUTCDateString()));
	const yyyyIST = nowIST.getFullYear();
	// const mmIST = String(nowIST.getMonth() + 1).padStart(2, "0");
	const ddIST = String(nowIST.getDate()).padStart(2, "0");

	const shortDate = `${ddIST}${nowIST.toLocaleString("en-US", {
		month: "short",
	})}${yyyyIST}`; // e.g. 23Oct2025

	try {
		const invoiceRef = ref(db, "invoices");
		const snapshot = await get(invoiceRef);

		let count = 0;
		if (snapshot.exists()) {
			const invoices = snapshot.val();
			Object.values(invoices).forEach((invoice: any) => {
				if (
					invoice.createdAt &&
					convertUTCToIST(invoice.createdAt).substring(0, 10) ===
						todayUTC
				) {
					count += 1;
				}
			});
		}

		return `INV-${shortDate}-${count + 1}`;
	} catch (error) {
		console.error("Error generating invoice number:", error);
		throw error;
	}
};
